<template>
    <div>
        <el-table
            ref="incoming-number-table"
            v-loading="loadingBundles"
            :data="bundles"
            class="w-full"
            stripe
        >
            <!-- Information Column -->
            <el-table-column
                prop="sid"
                label="Information"
                width="320"
            >
                <template v-slot="scope">
                    <InformationColumn
                        :row="scope.row"
                        :show-incoming-number="true"
                        :show-customer-profile="true"
                        :show-messaging-service="true"
                        :show-address="true"
                        :show-emergency-address="true"
                        :show-regulatory-bundle="true"
                        :show-stir-shaken-bundles="true"
                        :show-voice-integrity-bundles="true"
                        :show-toll-free-verification-column="true"
                    />
                </template>
            </el-table-column>

            <!-- Line Column -->
            <el-table-column
                label="Line"
                prop="campaign_id"
                width="250"
            >
                <template v-slot="scope">
                    <LineColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Country Column -->
            <el-table-column
                label="Country"
                prop="iso_country"
                width="90"
            >
                <template v-slot="scope">
                    {{ scope.row.iso_country || scope.row.country || '-' }}
                </template>
            </el-table-column>

            <!-- DNU Column -->
            <el-table-column
                label="DNU"
                prop="do_not_use"
                width="80"
            >
                <template v-slot="scope">
                    <span>{{ scope.row.do_not_use ? 'Yes' : 'No' }}</span>
                </template>
            </el-table-column>

            <!-- Emergency Address Status Column -->
            <el-table-column
                label="Emergency Address Status"
                prop="emergency_address_status"
            >
                <template v-slot="scope">
                    <b v-if="scope.row.emergency_address_status" class="label">
                        {{ scope.row.emergency_address_status }}
                    </b>
                    <span v-else>-</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import TimestampsColumn from '../columns/timestamps-column'
import InformationColumn from '../columns/information-column'
import LineColumn from '../columns/line-column'
import { compliance_mixin } from '../../../mixins'

export default {
    name: 'IncomingNumberTable',
    mixins: [compliance_mixin],
    components: {
        TimestampsColumn,
        InformationColumn,
        LineColumn,
    },
    props: {
        bundles: {
            type: Array,
            required: true,
        },
        loadingBundles: {
            type: Boolean,
            required: true,
        },
        company: {
            type: Object,
            required: true,
        },
        loadingUpdateBundle: {
            type: Array,
            default: () => [],
        },
        loadingDeleteBundle: {
            type: Array,
            default: () => [],
        },
    },
}
</script>
